import { useContext } from 'react';

import Card3D from '@/components/game/3d/object/card/Card3D';
import { stepStackedCardY } from '@/const/magicNumber';
import { ViewContext } from '@/state/contexts';
import { getCardTexturePath } from '@/util/card';

const EquipmentBuilder = ({ playerId, equipment }) => {
	const {
		showCardTableModal,
		setShowCardTableModal,
		cardsOnTablePlayerId,
		setCardsOnTablePlayerId,
	}: any = useContext(ViewContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	function displayCardsOnTableForPlayerId() {
		setCardsOnTablePlayerId(playerId);
		setShowCardTableModal(true);
	}

	if (equipment == null || equipment.length === 0) {
		return;
	}

	const eArray: any = [];

	for (let z = equipment.length - 1; z >= 0; z--) {
		const texturePath = getCardTexturePath(equipment[z]);

		eArray.push(
			<group
				key={`e_group__${z}`}
				position={[-11.5, stepStackedCardY * (z / 2), -1.5 + 1.5 * z]}
			>
				<Card3D
					key={`e__${z}`}
					texturePath={texturePath}
					cardArr={equipment}
					viewCardModal={displayCardsOnTableForPlayerId}
				/>
			</group>
		);
	}

	return <>{eArray}</>;
};

export default EquipmentBuilder;
